"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceLanguageEnum = void 0;
var VoiceLanguageEnum;
(function (VoiceLanguageEnum) {
    VoiceLanguageEnum["SE"] = "se";
    VoiceLanguageEnum["EN"] = "en";
    VoiceLanguageEnum["FI"] = "fi";
    VoiceLanguageEnum["DK"] = "dk";
    VoiceLanguageEnum["FR"] = "fr";
    VoiceLanguageEnum["DE"] = "de";
    VoiceLanguageEnum["NO"] = "no";
    VoiceLanguageEnum["PL"] = "pl";
})(VoiceLanguageEnum = exports.VoiceLanguageEnum || (exports.VoiceLanguageEnum = {}));
